// extracted by mini-css-extract-plugin
export var bubble = "_49-0";
export var container = "_49-f";
export var contrastBorder = "_49-g";
export var greyOut = "_49-2";
export var initialsColor0 = "_49-3";
export var initialsColor1 = "_49-4";
export var initialsColor10 = "_49-d";
export var initialsColor11 = "_49-e";
export var initialsColor2 = "_49-5";
export var initialsColor3 = "_49-6";
export var initialsColor4 = "_49-7";
export var initialsColor5 = "_49-8";
export var initialsColor6 = "_49-9";
export var initialsColor7 = "_49-a";
export var initialsColor8 = "_49-b";
export var initialsColor9 = "_49-c";
export var initialsWrapper = "_49-1";
export var large = "_49-l";
export var medium = "_49-k";
export var mediumSmall = "_49-j";
export var mediumSmallMedium = "_49-o";
export var micro = "_49-h";
export var small = "_49-i";
export var tiny = "_49-n";
export var xTiny = "_49-m";